import { render } from "./mobileSideBar.vue?vue&type=template&id=aafbc6f0"
import script from "./mobileSideBar.vue?vue&type=script&lang=js"
export * from "./mobileSideBar.vue?vue&type=script&lang=js"

import "./mobileSideBar.vue?vue&type=style&index=0&id=aafbc6f0&lang=scss"

import exportComponent from "/codebuild/output/src384613071/src/admin-ui-svc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__